<template>
  <div>
    <div class="headline d-print-none">
      <div class="bgTop"></div>
      <v-container class="bgTop_height">
        <v-row>
          <v-col class="logo"></v-col>
          <v-col v-if="user && !user.id.match(/Terminal/)" class="text-right">
            <v-menu
              open-on-hover
              origin="center center"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on }">
                <v-avatar
                  v-on="on"
                  :size="$vuetify.breakpoint.smAndUp ? 48 : 32"
                  :color="
                    user.avatar == '' ? 'grey lighten-4' : 'rgb(0, 0, 0, 0.0)'
                  "
                >
                  <span v-if="user.avatar == ''" class="text-h5">
                    {{ user.id | INITIALS }}
                  </span>
                  <img v-else :src="user.avatar" style="height: auto" />
                </v-avatar>
              </template>

              <v-card class="mx-auto">
                <v-list-item>
                  <v-avatar
                    size="48"
                    :color="
                      user.avatar == '' ? 'grey lighten-4' : 'rgb(0, 0, 0, 0.0)'
                    "
                    class="mr-3"
                  >
                    <span v-if="user.avatar == ''" class="text-h5">
                      {{ user.id | INITIALS }}
                    </span>
                    <img v-else :src="user.avatar" style="height: auto" />
                  </v-avatar>
                  <div class="my-3">
                    <v-list-item-title class="text-h6">
                      {{ user.id | FULLNAME }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ user.mail }}
                    </v-list-item-subtitle>
                  </div>
                </v-list-item>

                <v-divider></v-divider>

                <v-list shaped dense>
                  <!-- edit -->
                  <v-list-item @click="userEdit = true">
                    <v-icon class="ml-3 mr-6 info--text text--lighten-1">
                      mdi-account-outline
                    </v-icon>
                    <v-list-item-title>Bearbeiten</v-list-item-title>
                  </v-list-item>
                  <!-- admin -->
                  <template v-if="user.rights.admin">
                    <v-list-item @click="$router.push('/admin')">
                      <v-icon class="ml-3 mr-6 info--text text--lighten-1">
                        mdi-cog
                      </v-icon>
                      <v-list-item-title>Einstellungen</v-list-item-title>
                    </v-list-item>
                    <!-- statistic -->
                    <v-list-item @click="$router.push('/admin/statistic')">
                      <v-icon class="ml-3 mr-6 info--text text--lighten-1">
                        mdi-chart-bar
                      </v-icon>
                      <v-list-item-title>Statistik</v-list-item-title>
                    </v-list-item>
                    <!-- maillog -->
                    <v-list-item @click="$router.push('/admin/maillog')">
                      <v-icon class="ml-3 mr-6 info--text text--lighten-1">
                        mdi-email-outline
                      </v-icon>
                      <v-list-item-title>Mail-Log</v-list-item-title>
                    </v-list-item>
                  </template>
                  <!-- logout -->
                  <v-list-item @click="logout">
                    <v-icon
                      style="margin: 0 22px 0 14px"
                      class="text-center info--text text--lighten-1"
                    >
                      mdi-logout
                    </v-icon>
                    <v-list-item-title>Logout</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="bgTop_gap"></div>

    <!-- edit avatar -->
    <v-dialog v-if="user" persistent v-model="userEdit" max-width="820">
      <v-card>
        <v-card-title class="blue accent-1">
          <span class="text-h4 white--text">Avatar bearbeiten </span>
        </v-card-title>
        <v-card-text>
          <edit-avatar
            :avatar="user.avatar"
            @close="userEdit = false"
            @saveAvatar="saveAvatar($event)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EditAvatar from './_comp/EditAvatar.vue'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      userEdit: false,
    }
  },
  computed: {
    ...mapGetters(['user', 'getUserApps']),
  },
  methods: {
    ...mapMutations(['setUserAvatar']),
    ...mapActions(['logout']),
    saveAvatar(img) {
      this.$axios
        .put('pisa/user', {
          id: this.user.id,
          avatar: img,
          animate: this.user.animate,
          screenSaver: this.user.screenSaver,
          screenSaverTime: this.user.screenSaverTime,
        })
        .then(() => {
          this.user.avatar = img
          this.setUserAvatar(img)
          this.userEdit = false
        })
    },
  },
  components: {
    EditAvatar,
  },
}
</script>

<style scoped>
.headline {
  position: fixed;
  width: 100%;
  z-index: 95;
}

.bgTop {
  height: 250px;
  transform: skew(-4deg) rotate(-4deg);
  position: relative;
  top: -100px;
  backface-visibility: hidden;
  background-image: radial-gradient(
    at top,
    rgb(40, 50, 115),
    rgb(66, 139, 202)
  );
  background-image: -webkit-radial-gradient(
    50% 0%,
    rgb(40, 50, 115),
    rgb(66, 139, 202)
  );
  -webkit-box-shadow: -5px 0 10px 0 #808080;
  box-shadow: 0 5px 10px 0 #808080;
  margin-bottom: -50px;
  z-index: -1;
}

.bgTop_height {
  margin-top: -225px;
}

.bgTop_gap {
  height: 180px;
}

.logo {
  margin-left: 15px;
  width: 221px;
  height: 88px;
  background: url('data:image/png;base64,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')
    no-repeat;
}

@media (max-width: 599px) {
  .bgTop {
    height: 172px;
  }

  .bgTop_height {
    margin-top: -172px;
  }

  .bgTop_gap {
    height: 80px;
  }

  .logo {
    margin-top: 10px;
    width: 110px;
    height: 50px;
    background: url('data:image/png;base64,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')
      no-repeat;
  }
}
</style>
